import React, { useEffect, useState } from "react";
import { Avatar } from "primereact/avatar";
import { Image } from "primereact/image";
import { Chart } from "primereact/chart";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { setTab, setDefaultLanguage, setAppLanguage } from '../features/job/jobSlice';
import * as jobConstants from "../enums/jobs";
import UtilitiesService from "../services/util";
import labels_en from '../localization/labels.json';
import labels_fr from '../localization/labels_fr.json';
import { locale } from 'primereact/api';
import moment from 'moment';
import 'moment/locale/fr';

function Header() {
  const Util = new UtilitiesService();
  const urlPath = window.location.pathname;
  const navigate = useNavigate();
  const jobState = useSelector((state) => state.job);
  const { jobRecordsWidgit, currentTab, currentLanguage, appLanguage } = jobState;
  const authState = useSelector((state) => state.auth);
  const { user } = authState;
  const dispatch = useDispatch();
  const setCurrentTab = (tabId) => {
    dispatch(setTab(tabId));
    navigate("/")
  }

  useEffect(() => {
    if (currentTab == jobConstants.TABS.LIVE) {
      navigate("/")
    }
  }, []);

  // reports charts code start
  const overAllWidgitReports = {
    labels: [appLanguage["wedgit.label.received"], appLanguage["wedgit.label.processed"], appLanguage["wedgit.label.completed"]],
    datasets: [
      {
        backgroundColor: [jobConstants.HEADERREPORTWIDGET.RECEIVED, jobConstants.HEADERREPORTWIDGET.PROCESSED, jobConstants.HEADERREPORTWIDGET.COMPLETED],
        data: [jobRecordsWidgit?.receivedMetricWidget, jobRecordsWidgit?.processedMetricWidget, jobRecordsWidgit?.completedMetricWidget],
      },
    ],
  };

  let horizontalOptions = {
    indexAxis: "y",
    maintainAspectRatio: false,
    aspectRatio: 5,
    animation: false,
    scales: {
      x: {
        display: false, // Hide x-axis
        beginAtZero: true,
      },
      y: {
        display: false, // Hide y-axis
        beginAtZero: false,
      },
    },
    plugins: {
      legend: {
        display: false, // Hide legend
      },
    },
  };

  // change menu navigation
  const changeMenuNavigation = (tabType) => {
    setCurrentTab(tabType);
    if (tabType === jobConstants.TABS.CONFIGURATOR) {
      navigate("/favourites");
    }
    if (tabType === jobConstants.TABS.SLA) {
      navigate("/sla");
    }
    if (tabType === jobConstants.TABS.REPORTING) {
      navigate("/reports");
    }
    if (tabType === jobConstants.TABS.ADMIN) {
      navigate("/admin");
    }
    if (tabType === jobConstants.TABS.LIVE) {
      setCurrentTab(jobConstants.TABS.LIVE);
    }
    if (tabType === jobConstants.TABS.WATCHLIST) {
      setCurrentTab(jobConstants.TABS.WATCHLIST);
    }
    if (tabType === jobConstants.TABS.ERROR) {
      setCurrentTab(jobConstants.TABS.ERROR);
    }
    if (tabType === jobConstants.TABS.FAVOURITES) {
      setCurrentTab(jobConstants.TABS.FAVOURITES);
    }
  }

  useEffect(() => {
    dispatch(setDefaultLanguage(currentLanguage));
    if (currentLanguage === "EN") {
      moment.locale('en');
      locale('en');
      dispatch(setAppLanguage(labels_en));
    }
    if (currentLanguage === "FR") {
      moment.locale('fr');
      locale('fr');
      dispatch(setAppLanguage(labels_fr));
    }
  }, [currentLanguage]);

  const updateLanguage = (lang) => {
    dispatch(setDefaultLanguage(lang));
  }

  return (
    <header className="header">
      <div className="container">
        <div className="logo-wrap">
          <span className="brand-logo">
            <Image src="" alt="Xerx logo" width="106" />
          </span>
          {/* Multi-Channel Engagement Platform */}
          {appLanguage["header.label.title"]}
        </div>
      </div>
      <div className="topNavbar">
        <div className="container">
          <div className="top-nav">
            <ul className="navbarWrap">
              <li>{appLanguage["topheader.label.select-language"]}</li>
              <li>
                <select onChange={(e) => updateLanguage(e.target.value)} style={{width:'50px', height:'25px', borderRadius:'6px'}}>
                  <option value="EN" id="EN" style={{textAlign:'center'}}>EN</option>
                  <option value="FR" id="FR" style={{textAlign:'center'}}>FR</option>
                </select>
              </li>
            </ul>
            <ul className="navbarWrap">
              {/* <li>User Admin</li> */}
              <li>{user.fullName}</li>
              <li><Avatar icon="pi pi-user" /></li>
            </ul>
          </div>
        </div>
      </div>
      {urlPath !== '/sla-expended-report' && urlPath !== '/custom-business-volumn-expended-report' && urlPath !== '/custom-average-volumn-expended-report' && urlPath !== '/current-status-expended-report' && (
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="mainNavbar">
                <div className="left">
                  <ul>
                    {currentTab !== jobConstants.TABS.WATCHLIST && currentTab !== jobConstants.TABS.LIVE && currentTab !== jobConstants.TABS.ERROR && currentTab !== jobConstants.TABS.FAVOURITES ? (
                      <li>
                        <a className={currentTab == jobConstants.TABS.HOME ? 'active' : ''} onClick={() => changeMenuNavigation(jobConstants.TABS.LIVE)}>
                          <i className="home-icon"></i>
                          {/* <span>{jobConstants.MAINTABLEBEL.HOME}</span> */}
                          <span>{appLanguage["menu.btn.home"]}</span>
                        </a>
                      </li>
                    ) : (
                      <>
                        <li>
                          <a className={currentTab == jobConstants.TABS.WATCHLIST ? 'active' : ''} onClick={() => changeMenuNavigation(jobConstants.TABS.WATCHLIST)}>
                            <i className="watch-list-icon"></i>
                            {/* <span>{jobConstants.MAINTABLEBEL.WATCHLIST}</span> */}
                            <span>{appLanguage["menu.btn.watchlist"]}</span>
                          </a>
                        </li>
                        <li>
                          <a className={currentTab == jobConstants.TABS.LIVE ? 'active' : ''} onClick={() => changeMenuNavigation(jobConstants.TABS.LIVE)}>
                            <i className="live-icon"></i>
                            {/* <span>{jobConstants.MAINTABLEBEL.LIVE}</span> */}
                            <span>{appLanguage["menu.btn.live"]}</span>
                          </a>
                        </li>
                        <li>
                          <a className={currentTab == jobConstants.TABS.ERROR ? 'active' : ''} onClick={() => changeMenuNavigation(jobConstants.TABS.ERROR)}>
                            <i className="error-icon"></i>
                            {/* <span>{jobConstants.MAINTABLEBEL.ERROR}</span> */}
                            <span>{appLanguage["menu.btn.error"]}</span>
                          </a>
                        </li>
                        <li>
                          <a className={currentTab == jobConstants.TABS.FAVOURITES ? 'active' : ''} onClick={() => changeMenuNavigation(jobConstants.TABS.FAVOURITES)}>
                            <i className="favourites-icon"></i>
                            {/* <span>{jobConstants.MAINTABLEBEL.FAVOURITES}</span> */}
                            <span>{appLanguage["menu.btn.favourites"]}</span>
                          </a>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
                <div className="right">
                  <ul>
                    <li>
                      <a className={currentTab == jobConstants.TABS.CONFIGURATOR ? 'active' : ''} onClick={() => changeMenuNavigation(jobConstants.TABS.CONFIGURATOR)}>
                        <i className="preferences-icon"></i>
                        {/* <span>{jobConstants.MAINTABLEBEL.CONFIGURATOR}</span> */}
                        <span>{appLanguage["menu.btn.preferences"]}</span>
                      </a>
                    </li>
                    <li>
                      <a className={currentTab == jobConstants.TABS.SLA ? 'active' : ''} onClick={() => changeMenuNavigation(jobConstants.TABS.SLA)}>
                        <i className="sla-icon"></i>
                        {/* <span>{jobConstants.MAINTABLEBEL.SLA}</span> */}
                        <span>{appLanguage["menu.btn.sla"]}</span>
                      </a>
                    </li>
                    <li>
                      <a className={currentTab == jobConstants.TABS.REPORTING ? 'active' : ''} onClick={() => changeMenuNavigation(jobConstants.TABS.REPORTING)}>
                        <i className="reporting-icon"></i>
                        {/* <span>{jobConstants.MAINTABLEBEL.REPORTING}</span> */}
                        <span>{appLanguage["menu.btn.reporting"]}</span>
                      </a>
                    </li>
                    {/* <li>
                      <a className={currentTab == jobConstants.TABS.ADMIN ? 'active' : ''} onClick={() => changeMenuNavigation(jobConstants.TABS.ADMIN)}>
                        <i className="admin-icon"></i>
                        <span>{jobConstants.MAINTABLEBEL.ADMIN}</span>
                      </a>
                    </li> */}
                  </ul>
                  <div className="reports-block">
                    {/* <p>{jobConstants.MAINTABLEBEL.RECORDS}</p> */}
                    <p>{appLanguage["wedgit.label.records"]}</p>
                    <div className="repors-graph-wrap">
                      <ul>
                        <li>
                          {/* <span className="bars-text">{jobConstants.HEADERWIDGETLEBEL.RECEIVED}</span>{" "} */}
                          <span className="bars-text">{appLanguage["wedgit.label.received"]}</span>{" "}
                        </li>
                        <li>
                          {/* <span className="bars-text">{jobConstants.HEADERWIDGETLEBEL.PROCESSED}</span>{" "} */}
                          <span className="bars-text">{appLanguage["wedgit.label.processed"]}</span>{" "}
                        </li>
                        <li>
                          {/* <span className="bars-text">{jobConstants.HEADERWIDGETLEBEL.COMPLETED}</span>{" "} */}
                          <span className="bars-text">{appLanguage["wedgit.label.completed"]}</span>{" "}
                        </li>
                      </ul>
                      <div className="repors-graph-wrap-inner">
                        <Chart
                          type="bar"
                          data={overAllWidgitReports}
                          options={horizontalOptions}
                          className="reportChatWidget"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
